import APIService from '@/services/APIService';

const BASE_URL = 'gpt-pulse';

export default {
  getKnowledgeBases(params) {
    return APIService.get(`${BASE_URL}/knowledge-bases`, { params, rOptions: { many: true } });
  },
  getKnowledgeBaseByMessage(id, params) {
    return APIService.get(`${BASE_URL}/knowledge-bases/by-message/${id}`, params);
  },
  showKnowledgeBase(id, params) {
    return APIService.get(`${BASE_URL}/knowledge-bases/${id}`, params);
  },
  deleteKnowledgeBase(id, params) {
    return APIService.delete(`${BASE_URL}/knowledge-bases/${id}`, params);
  },
  createKnowledgeBases(data) {
    return APIService.post(`${BASE_URL}/knowledge-bases`, data);
  },

  getCourseGptSettings(params) {
    return APIService.get(`${BASE_URL}/courses/gpt-pulse-settings`, { params });
  },
  createCourseGptSettings(id, data) {
    return APIService.post(`${BASE_URL}/courses/${id}/gpt-pulse-settings`, data);
  },

  createModuleGptSettings(id, data) {
    return APIService.post(`${BASE_URL}/course-modules/${id}/gpt-pulse-settings`, data);
  },
  getModuleGptSettings(params) {
    return APIService.get(`${BASE_URL}/course-modules/gpt-pulse-settings`, { params });
  },

  getTaskGptSettings(params) {
    return APIService.get(`${BASE_URL}/task-units/gpt-pulse-settings`, params);
  },

  createUnitGptSettings(id, data) {
    return APIService.post(`${BASE_URL}/course-units/${id}/gpt-pulse-settings`, data);
  },
  getUnitGptSettings(params) {
    return APIService.get(`${BASE_URL}/course-units/gpt-pulse-settings`, { params });
  },

  updateGptSettings(id, data) {
    return APIService.put(`${BASE_URL}/gpt-pulse-settings/${id}`, data);
  },

  getBaseQuestions(id, params) {
    return APIService.get(`${BASE_URL}/knowledge-bases/${id}/questions`, { params, rOptions: { many: true } });
  },

  createQuestion(data) {
    return APIService.post(`${BASE_URL}/send-data`, data);
  },

  processedMessage(id, data) {
    return APIService.post(`${BASE_URL}/gpt-requests/${id}/processed`, data);
  },
};
